<template>
  <div id="app">
    <div class="modal_body">
      <div v-if="recordBatchStatus !== ''" class="view_wrap">
        <dl>
          <dt>대화 이력</dt>
          <dd>
            성공한 가상상담 상세 대화내역(텍스트)
            <ur-button
              shape="hyperlink"
              primary
              medium
              @click="onClickCommDownload"
            >
              다운로드
            </ur-button>
          </dd>
          <br>
          <dt>답변 결과</dt>
          <dd>
            성공한 가상상담 답변 결과내역
            <ur-button
              shape="hyperlink"
              primary
              medium
              @click="onClickSurveyDownload"
            >
              다운로드
            </ur-button>
          </dd>
          <br>
          <dt>녹취 파일</dt>
          <dd>
            성공한 가상상담 상세 대화내역(음성)
            <span
              v-if="!recordFileUploadDone"
              class="record-note"
            >
              준비중</span>
            <span
              v-else-if="recordZipFileRequestExpired"
              class="record-note"
            >
              신청 기한 만료
            </span>
            <span v-else-if="requestable">
              <ur-button
                shape="hyperlink"
                primary
                medium
                @click="onClickBatchRequest"
              >
                신청
              </ur-button>
            </span>
            <span
              v-else-if="requestDone"
              class="record-note"
            >
              신청 완료</span>
            <span
              v-else-if="noFile"
              class="record-note"
            >
              파일 없음</span>
            <br>
            <span style="font-size: 14px; color: #999">* 신청 가능 기간(~ {{recordZipFileRequestExpireDate}})</span>
            <br>
            <br>
            <div v-if="downloadable">
              <ur-data-grid
                ref="grid"
                style="margin-top: -8px"
                :options="options"
                :headers="headers"
                :data-source="zipFileList"
                @grid:click="clickEvent"
              >
                <template #header="{headers}">
                  <ur-data-grid-header-cell>
                    <div class="h-title-text">
                      {{headers[0].text}}
                      <span style="font-size: 14px; color: #999; margin-left: 10px;">
                        * 다운로드 기간(~ {{recordZipFileDownloadExpireDate}})
                      </span>
                    </div>
                  </ur-data-grid-header-cell>
                </template>
              </ur-data-grid>
            </div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_AIC_00004_T03',
  extends: BasePage,
  components: {
    BasePage,
  },

  props: {},

  data() {
    return {
      pageId: 'PGE_AIC_00004',
      outCallScheduleAsk: {
        scheduleId: '',
      },
      recordDataAsk: {
        fileId: '',
      },
      recordFileAmount: 0,
      recordBatchStatus: '',
      recordFileUploadDone: false,
      recordZipFileRequestExpired: true,
      recordZipFileRequestExpireDate: '',
      recordZipFileDownloadExpireDate: '',
      recordZipFileExist: false,
      zipFileList: [],
      options: {
        msgTotal: '총 #',
        infinityScroll: true,
        height: 200,
        headerHeight: 34,
        rowHeight: 34,
        multiSelect: false,
        selectCheck: false,
        msgEmptyData: '', // 조회 완료 후에 문구 출력
      },
      headers: [
        { text: '파일 이름', value: 'fileName' },
      ],

      // 대화이력 다운로드
      commDownloadList: [],

      // 설문결과 다운로드
      fileType: 'text/csv;charset=utf-8',
      surveyFileName: '',
      surveyResultHeaders: [],
      surveyResultList: [],
    };
  },

  computed: {
    requestable() {
      // 개별 녹취파일이 모두 스토리지에 업로드 and 녹취파일 일괄 다운로드 신청기한 만료 전 and 개별 녹취파일이 1개 이상 and (신청 이력 없음 or (배치 완료 and 압축파일 없음))
      return this.recordFileUploadDone && !this.recordZipFileRequestExpired && this.recordFileAmount > 0 && (this.recordBatchStatus === 'D' || (this.recordBatchStatus === 'B' && !this.recordZipFileExist));
    },

    requestDone() {
      // 신청 완료 or 배치 오류
      return this.recordBatchStatus === 'A' || this.recordBatchStatus === 'C';
    },

    downloadable() {
      // 배치 완료 and 압축파일 있음
      return this.recordBatchStatus === 'B' && this.recordZipFileExist;
    },

    noFile() {
      // 개별 녹취파일이 없음
      return this.recordFileAmount === 0;
    },

    surveyDownloadData() {
      const headerIndexArr = [];
      for (let i = 0; i < this.surveyResultHeaders.length; i += 1) {
        headerIndexArr.push(i);
      }
      const dataString = aiccUtils.stringUtil.tableToCsvDataString(this.surveyResultHeaders, this.surveyResultList, headerIndexArr);
      return dataString;
    },
  },

  watch: {},

  mounted() {
  },

  methods: {
    getRecordFileStatus(parentPageId, scheduleId) {
      this.pageId = parentPageId;
      this.recordBatchStatus = '';
      this.outCallScheduleAsk.scheduleId = scheduleId;
      http.request(this.pageId, 'DTS_AIC_00025', {
        query: this.outCallScheduleAsk,
      }).then((response) => {
        this.recordFileAmount = response.data.list.length;
        this.recordFileUploadDone = response.data.recordFileUploadDone;
        this.recordZipFileRequestExpired = response.data.recordZipFileRequestExpiration.expired;
        this.recordZipFileRequestExpireDate = response.data.recordZipFileRequestExpiration.expireDate;
        if (response.data === null || response.data.recordBatch === null) {
          this.recordBatchStatus = 'D';
        } else {
          this.recordBatchStatus = response.data.recordBatch.status;
          this.recordZipFileDownloadExpireDate = response.data.recordBatch.downloadExpireDate;
          this.recordZipFileExist = response.data.recordBatch.fileExist;
          if (response.data.recordBatch.fileExist) {
            this.zipFileList = response.data.recordBatch.recordZipFileList;
          }
        }
      });

      this.getCommDownloadList();
      this.getSurveyResultList();
    },

    getSurveyResultList() {
      http.request(this.pageId, 'DTS_AIC_00028', {
        query: {
          scheduleId: this.outCallScheduleAsk.scheduleId,
        },
      }).then((response) => {
        this.surveyFileName = response.data.surveyFileName;

        this.surveyResultHeaders = [
          { text: '세션ID', value: 'sessionId' },
          { text: '수행일시', value: 'outcallReqTime' },
          { text: '수신번호', value: 'calleeNumber'},
          { text: '수신ID', value: 'calleeId' },
          { text: '시도 순서', value: 'retryTimes' },
          { text: '고객ID', value: 'customerId' },
          { text: '처리결과', value: 'outcallResultData' },
        ];

        utils.forEach(response.data.surveyItemList, (rowobj) => {
          this.surveyResultHeaders.push(
            { text: rowobj.surveyItemName, value: rowobj.surveyItemKey },
          );
        });

        utils.forEach(response.data.surveyResultList, (rowobj) => {
          if (!rowobj.calleeNumber) {
            rowobj.calleeNumber = rowobj.calleeNumber1;
          }

          rowobj.outcallReqTime = utils.toStringByFormat(aiccUtils.conversationDownload.changeTimeZoneAndFormat(rowobj.outcallReqTime), "YYYY-MM-DD HH:mm");
          rowobj.retryTimes = (rowobj.retryTimes + 1) + '회';
          // 재시도 콜의 item_index를 캠페인 수신리스트 작성시 최초 채번된 item_index로 보정하고, 정해진 수신ID 포맷으로 변환
          rowobj.calleeId = aiccUtils.stringUtil.itemIndexToCalleeId(rowobj.itemIndex);
        });

        this.surveyResultList = response.data.surveyResultList;
      });
    },

    onClickBatchRequest() {
      http.request(this.pageId, 'DTS_AIC_00026', {
        query: this.outCallScheduleAsk,
      }).then((response) => {
        utils.aiccMessageBox('알림', '파일 일괄 다운로드 신청이 완료되었습니다.', '확인', null);
        this.recordBatchStatus = 'A';
      });
    },

    // 일괄 다운로드 이력 남기기
    onClickDownload(row) {
      const historyData = {
        pageId: this.pageId,
        fileName: row.fileName,
        fileDetail: `Campaign Id : ${this.outCallScheduleAsk.scheduleId}`,
      };
      http.request(this.pageId, 'DTS_AIZ_00001', {
        data: historyData,
      }).then((res) => {
        if (res.status === 200) {
          this.downloadRecordZipFile(row.fileId);
        } else {
          utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
        }
      });
    },

    // 일괄 다운로드
    downloadRecordZipFile(fileId) {
      this.recordDataAsk.fileId = fileId;
      http.request(this.pageId, 'DTS_AIC_00027', {
        responseType: 'blob',
        query: this.recordDataAsk,
      }).then((response) => {
        if (response.data.size > 0) {
          var recordFilename = (response.headers['content-disposition'] || '').split('filename=')[1].split(';')[0];
          var audioBlobUrl = aiccUtils.fileDownload.getBlobUrl(response.data, 'application/zip');

          aiccUtils.fileDownload.download(audioBlobUrl, decodeURIComponent(recordFilename));
        } else {
          utils.aiccMessageBox('알림', '파일 다운로드에 실패했습니다.', '확인', null);
        }
      });
    },
    
    // 데이터 그리드
    clickEvent(cell, row, field, e) {      
      if (typeof e === 'object') {
        if (e.button === 0) { // 마우스 메인 버튼만 유효
          this.onClickDownload(row);
        }
      }
    },

    // 대화이력 조회
    getCommDownloadList() {
      const dataParams = {
        startDate: '0', // 수행일정 전체
        endDate: '9',
        campaignIdList: [
          this.outCallScheduleAsk.scheduleId,
        ],
        campaignTypeList: [ // 시나리오 상태 전체
          'SY',
          'SN',
          'EY',
          'EN',
        ],
        tellerOption: 'AL', // 상담원 요청 전체
        outcallResultData: '',
        calleeNumber: '',
        outcallResultList: [ // 통화연결 전체
          'SC',
        ],
      };

      http.request(this.pageId, 'DTS_AIC_00006', {
        data: dataParams,
      }).then((response) => {
          if (response.data.list) {
            // conversation 데이터
            utils.forEach(response.data.list, (rowobj) => {
              // 수신번호
              if (!rowobj.calleeNumber) {
                rowobj.calleeNumber = rowobj.calleeNumber1;
              }

              // 시나리오 시작/종료 object 생성
              const scenarioStartEnd = {
                start: rowobj.scenarioStartTime ? "Y" : "N",
                end: rowobj.scenarioEndTime ? "Y" : "N",
              };
              rowobj["scenarioStartEnd"] = scenarioStartEnd;

              // 시도순서
              rowobj.retryTimes = rowobj.callResult === "N" ? -1 : rowobj.retryTimes + 1;
            });

            this.commDownloadList = response.data.list;
          }

        }).catch((error) => {
          console.warn(error);
        });
    },

    // 대화이력 다운로드
    onClickCommDownload() {
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sCsvName = `conv_history_${sToday}.csv`;

      const historyDataAsk = {
        pageId: this.pageId,
        fileName: sCsvName,
        fileDetail: `Campaign Id : ${this.outCallScheduleAsk.scheduleId}`,
      };
      // 대화이력 다운로드 이력 남기기
      http.request(this.pageId, 'DTS_AIZ_00001', {
          data: historyDataAsk,
        }).then((res) => {
          if (res.status === 200) {
            aiccUtils.conversationDownload.getAndMakeConversationFile(
              this.pageId,
              sCsvName,
              this.commDownloadList
            );
          } else {
            utils.aiccMessageBox(
              "알림",
              "잠시 후 다시 시도해주세요.",
              "확인",
              null
            );
          }
        });
    },

    // 설문결과 다운로드
    onClickSurveyDownload() {
      const url = aiccUtils.fileDownload.getBlobUrl(this.surveyDownloadData, this.fileType);
      const fileName = `${this.surveyFileName}.csv`;
      const historyDataAsk = {
        pageId: this.pageId,
        fileName: fileName,
        fileDetail: `Campaign Id : ${this.outCallScheduleAsk.scheduleId}`,
      };
      // 대화이력 다운로드 이력 남기기
      http.request(this.pageId, 'DTS_AIZ_00001', {
          data: historyDataAsk,
      }).then((res) => {
        if (res.status === 200) {
          aiccUtils.fileDownload.download(url, fileName);
        } else {
          utils.aiccMessageBox(
            "알림",
            "잠시 후 다시 시도해주세요.",
            "확인",
            null
          );
        }
      });
    },
  },

};
</script>

<style scoped>
.ur-data-grid {
  min-width: 0px;
  width: 700px;
  overflow: hidden;
}
.record-note{
  margin-left: 24px;
}
</style>
